export default __webpack_public_path__ + "static/media/sell-image7.39dc1b80.png";